import "../../App.css";
import React from "react";
import COSMETIC_DENTISTRY from "../Cosmetic_Dentistry";
import CONTACT_US from "../footer";
import Accordian from "../../accordian/accordian";
import ScrollArrow from "../ScrollUp";
import BackBtn from "../BackBtn";

function COSMETIC_DENTISTRY_Page() {
  return (
    <>
      <COSMETIC_DENTISTRY />
      <Accordian
        title="How do I know If I need Orthodontics "
        content="Just your dental practitioner or orthodontist can decide if orthodontics is beneficial for you or not.  After a clinical examination of your teeth and extraordinary X-rays and photos, an orthodontist or dental practitioner can build up a treatment plan."
      />
      <Accordian
        title=" Why should I get Orthodontic treatment "
        content="  There are two valid justifications: Aesthetic and Function. Having an alluring grin or smile, it not just changes the manner in which individuals see you — it upgrades your own mental self-view and personality too. Orthodontic treatment additionally enables your teeth to function better and makes it less demanding to keep them clean, which can enhance your general wellbeing."
      />
      <Accordian
        title=" What is the correct age of the orthodontic treatment"
        content="EARLY TREATMENT – The Indian Association of Orthodontists recommends that children receive an orthodontic evaluation by the age of 7. Early interceptive treatment, referred to as Phase I, is performed before all of the permanent teeth have erupted—often between the ages of 7 and 10. Early evaluation provides both timely detection of problems and greater opportunity for more effective treatment.</br>
             TEEN TREATMENT - Adolescents regularly begin full orthodontic treatment between the ages of 12 and 16 once the greater part of their teeth have been extracted. Full orthodontic treatment, referred to as Phase II who got early treatment, will position all the teeth to enhance their appearance and capacity.</br>
              ADULT TREATMENT - Orthodontic treatment amid adulthood can extremely enhance your own appearance and certainty. Orthodontics offers a few treatment choices for grown-ups, including discrete and snappy clear aligners.</br>"
      />
      <ScrollArrow />
      <BackBtn />
      <CONTACT_US />
    </>
  );
}
export default COSMETIC_DENTISTRY_Page;
